import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { getYearLabel } from '../../../Common/Util/getYearLabel';
import { useConditionalityChartsDataContext } from './hooks/useConditionalityChartsDataContext';

export const ChildrenSchoolAttendanceComparisonPercentageAnual = () => {
    const { chartData } = useConditionalityChartsDataContext();

    return (
        <SimpleBars
            title={'Comparação de Frequência Escolar - Percentual (Anual)'}
            horizontal={false}
            subtitles={chartData?.childrenSchoolAttendanceComparisonPercentageAnual?.map((item) => getYearLabel(item.ano))}
            values={chartData?.childrenSchoolAttendanceComparisonPercentageAnual?.map((item) => item.percentage || 0)}
        />
    );
};
